import React, { useEffect, useRef, useState } from 'react'
import { SharedControlProps } from '../../models/Common'
import { SelectItem } from '../../models/SelectIem'
import RefDataService from '../../services/RefDataService'
import { buildSelectItem } from '../../utilities/commonFunctions'
import FWOSelectInput from '../form/FWOSelectInput'

const FWOCustomerTypes = (props: SharedControlProps) => {
  const [data, setData] = useState<SelectItem[]>([])
  const [isLoading, setIsLoading] = useState(false)
  const mountedRef = useRef(false)

  useEffect(() => {
    mountedRef.current = true
    if (mountedRef.current && !props.options) {
      setIsLoading(true)

      RefDataService.getCustomerTypes()
        .then((response) => {
          if (mountedRef.current) {
            const result = response.result
            setData(buildSelectItem(result, true))
          }
        })
        .catch((error) => {
          props.hasError(error)
        })
        .finally(() => {
          if (mountedRef.current) {
            setIsLoading(false)
          }
        })
    }

    return () => {
      mountedRef.current = false
    }
  }, [props.options])

  return (
    <FWOSelectInput
      name={props.name}
      label={props.label ? props.label : props.name}
      placeholder={props.placeholder ? props.placeholder : props.name}
      required={props.required}
      options={props.options ? props.options : data}
      loading={isLoading}
      tooltip={props.tooltip}
      showreadonly={props.showreadonly}
    />
  )
}

export default FWOCustomerTypes
